const s = {
  name: "NewspaperPress",
  dimensions: { width: 40, height: 37 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 37" style="enable-background:new 0 0 40 37;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M35,5H11v2h24V5z"/>
		<path class="st0" d="M11,10h9v2h-9V10z"/>
		<path class="st0" d="M20,15h-9v2h9V15z"/>
		<path class="st0" d="M11,20h9v2h-9V20z"/>
		<path class="st0" d="M35,25H11v2h24V25z"/>
		<path class="st0" d="M11,30h24v2H11V30z"/>
		<path class="st0" d="M35,10H23v12h12V10z M25,20v-8h8v8H25z"/>
		<path class="st0" d="M6,0h34v32c0,2.8-2.2,5-5,5H4c-2.2,0-4-1.8-4-4V10h6V0z M35,35c1.7,0,3-1.3,3-3V2H8v31c0,0.7-0.2,1.4-0.5,2
			H35z M2,12v21c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2V12H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as NewspaperPress
};
